export default __webpack_public_path__ + "img/filters.90e78f8b.svg";